<template>
		<div>
			<div v-if="!dataReporting">
				<div id="favoris">
					<label style="margin-right:10px;">Rapport favori:</label>
					<v-multiselect
						placeholder="--- Aucun ---"
						selectLabel="Appuyez sur entrée pour sélectionner"
						deselectLabel="Appuyez sur entrée pour désélectionner"
						v-model="favoriSelected"
						:options="favoris"
						track-by="id"
						label="name"
						style="width:350px; display:inline-block" 
					> 
					</v-multiselect>
					<div class="btnFav btn btn-outline-primary" v-on:click="generateFavorite">Générer</div>
					<div class="btnFav btn btn-outline-secondary" v-on:click="deleteFavorite">Supprimer</div>
				</div>
				<form class="editForm shadow">
					<div class="selectInput">
						<label>Projet(s) : </label>
						<v-multiselect
							placeholder="Choisir un projet ..."
							selectLabel="Appuyez sur entrée pour sélectionner"
							deselectLabel="Appuyez sur entrée pour désélectionner"
							v-model="projectSelected"
							:options="filterProjects"
							:multiple="true"
							:close-on-select="false"
							track-by="project_id"
							:custom-label="labelProjects"
						>
						</v-multiselect>
					</div>
					<div class="selectInput">
						<label>Utilisateur(s) : </label>
						<v-multiselect
							placeholder="Choisir un utilisateur ..."
							selectLabel="Appuyez sur entrée pour sélectionner"
							deselectLabel="Appuyez sur entrée pour désélectionner"
							v-model="userSelected"
							:options="filterUsers"
							:multiple="true"
							:close-on-select="false"
							track-by="id"
							label="name"
						>
						</v-multiselect>
					</div>
					<div v-if="periodSelected == '' || periodSelected == undefined" class="selectInput">
						<div id="datePicker1" class="selectImputMidWith">
							<label for="editName">Date de début: </label>
							<v-date-picker 
								v-model="beginDate" 
								:popover="{ placement: 'bottom', visibility: 'click' }" 
								:first-day-of-week="2"
								locale="fr-FR"
							/>
							<label for="radioDate">
								<input id="radioDate" type="radio" v-model="typeDate" value="date">
								Date des saisies
							</label>
						</div>
						<div id="datePicker2" class="selectImputMidWith">
							<label for="editName">Date de fin: </label>
							<v-date-picker
								v-model="endDate" 
								:popover="{ placement: 'bottom', visibility: 'click' }"
								:first-day-of-week="2"
								locale="fr-FR" 
							/>
							<label for="radioModif">
								<input id="radioModif" type="radio" v-model="typeDate" value="modif">
								Date de dernière modification des saisies
							</label>
						</div>
					</div>
					<div v-if="beginDate == null && endDate == null" class="selectInput">
						<label>Sélectionner la période de temps : </label>
						<v-multiselect
							placeholder="Choisir une période ..."
							selectLabel="Appuyez sur entrée pour sélectionner"
							deselectLabel="Appuyez sur entrée pour désélectionner"
							v-model="periodSelected"
							:options="periods"
							track-by="id"
							label="value" 
						> 
						</v-multiselect>
					</div>
					<div class="selectInput">
						<label>Afficher les champs</label>
						<div id="checkboxInput">
							<label for="checkboxProjet"><input id="checkboxProjet" type="checkbox" value="project" v-model="checkedField"> Projet</label>
							<label for="checkboxUser"><input id="checkboxUser" type="checkbox" value="user" v-model="checkedField"> Utilisateur</label>
							<label for="checkboxDuree"><input id="checkboxDuree" type="checkbox" value="duration" v-model="checkedField"> Durée</label>
							<label for="checkboxNote"><input id="checkboxNote" type="checkbox" value="note" v-model="checkedField"> Note</label>
						</div>
					</div>
					<div class="selectInput">
						<div class="selectImputMidWith">
							<label>Regroupés par</label>
							<v-multiselect
								placeholder="Aucun regroupement ..."
								selectLabel="Appuyez sur entrée pour sélectionner"
								deselectLabel="Appuyez sur entrée pour désélectionner"
								v-model="regroupingSelected"
								:options="regrouping"
								track-by="id"
								label="value" 
							> 
							</v-multiselect>
						</div>
						<div class="selectImputMidWith">
							<div id="checkboxInput">
								<label for="checkbox"><input id="checkbox" type="checkbox" v-model="total"> Total uniquement</label>
							</div>
						</div>
						<div v-if="total && (regroupingSelected == '' || regroupingSelected == undefined)">
							<p class="error"> Un regroupement doit être sélectionné pour générer un rapport avec totaux uniquement !</p>
						</div>
					</div>
					<div class="selectInput" style="background:#efefef; padding: 10px">
						<label style="margin-right:10px">Enregistrer comme favori : </label>
						<input type="text" v-model="nameFavorite" style="min-width: 300px;margin-bottom:0" placeholder="Saisir un nom de favori........">
						<div class="btn row btn-outline-secondary" v-on:click="addFavorite" style="display: inline-block; margin-left: 15px; width: auto;">
							Sauvegarder
						</div>
					</div>
					<div class="error row" v-if="errors.length">
						<p v-for="error in errors" v-bind:key="error">{{ error }}</p>
					</div>
					<div class="btn row btn-outline-success" v-on:click="getExport">
						<b-icon icon="gear-fill" animation="spin" font-scale="2" v-if="loading"></b-icon>
						<span v-else>Valider</span>
					</div>
				</form>
			</div>
			<div v-else>
				<div id="actionExport">
					<div id = "export" class="btn btn-outline-primary" v-on:click="exportReport">Exporter le rapport (.xlsx)</div>
					<div id="newExport" class="btn btn-outline-secondary" v-on:click="newReport">Nouveau rapport</div>
				</div>
				<div id="renderData" class="shadow">
					<p class="error">{{errorDB}}</p>
					<table>
						<thead>
							<tr>
								<th v-for="header in headerReporting" :key="header.id">
									{{ header.value }}
								</th>
							</tr>
						</thead>
						<tbody>
							<template v-for="(rowData, indexData) in dataReporting">
								<tr v-for="(row, index) in rowData.data" :key="indexData+index">
									<td v-for="(header,id_i) in headerReporting" :key="header.id + id_i">
										{{ row[header.id] }}
									</td>
								</tr>
								<tr :key="indexData+'-st'" v-if="typeof rowData.subtotal != 'undefined'" style="background:#d9d9d9">
									<td :colspan="headerReporting.length - 1" style="text-align:right">Sous-total</td><td>{{ formatDuration(rowData.subtotal) }}</td>
								</tr>
							</template>
							<tr class="separator_table"></tr>
							<tr>
								<td>Total</td><td>{{ formatDuration(totalReporting) }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
</template>

<script>

	const axios = require('axios');

	export default {
		name: "ReportExport",
		data() {
			return {
				userId: 0,
				favoris: [],
				favoriSelected: false,
				nameFavorite:'',
				dataReporting: false,
				headerReporting: [],
				totalReporting: 0,
				projects: [],
				users: [],
				filterProjects: [],
				filterUsers: [],
				projectSelected: [],
				userSelected: [],
				checkedField: ["project","user","begin","end","duration","note"],
				periods: [
					{id:"currentYear", value:"Année en cours"},
					{id:"currentMonth", value:"Mois en cours"},
					{id:"lastMonth", value:"Le mois dernier"},
					{id:"currentWeek", value:"Semaine en cours"},
					{id:"lastWeek", value:"La semaine dernière"},
					{id:"today", value:"Aujourd'hui"},
					{id:"yesterday", value:"Hier"},
				],
				regrouping: [
					{id:'date', value:'Date'},
					{id:"project", value:"Projet"},
					{id:"users", value:"Utilisateurs"}
				],
				beginDate: null,
				endDate: null,
				typeDate: 'date',
				modifDate: '',
				periodSelected:'',
				regroupingSelected:'',
				json_fields: {},
				total: false,
				errors: [],
				errorDB: "",
				loading: false,
				headersText: {
					'date' : 'Date',
					'projectRef' : 'Référence projet',
					'projectName' : 'Projet',
					'userName' : 'Utilisateur',
					'duration' : 'Durée',
					'comment' : 'Note',
					'modifDate' : 'Date de modification',
				}
			}
		},
		created: function() {
			this.userId = Number(localStorage.id);
			axios.get(this.$store.state.apiUrl + "project/getAll", {
					params: {
							login: localStorage.login,
							password: localStorage.pass
					}
			})
			.then(response => {
				this.projects = response.data;
				this.filterProjects = this.projects;

				axios.get(this.$store.state.apiUrl + "user/users", {
						params: {
								login: localStorage.login,
								password: localStorage.pass
						}
				})
				.then(responseUser => {
					this.users = responseUser.data;
					this.filterUsers = this.users;
					this.getAllFavoriteReport();
				});

			});
		},
		methods: {
			organiseData: function(data) {
				var tmpUsers = [];
				if (data) {
					data.forEach(value => {
						value.usersLinked.forEach(user => {
							var indexU = tmpUsers.findIndex(tmpUser => tmpUser.id == user.id);
							if(value.status){
								if (indexU < 0) {
									indexU = tmpUsers.push(user) - 1;
									tmpUsers[indexU].projects = [value.project_id];
								} else {
									tmpUsers[indexU].projects.push(value.project_id);
								}
							}
						});
					});
				}
				this.projects = data;
				this.users = tmpUsers;
				this.filterProjects = data;
				this.filterUsers = tmpUsers;
			},
			labelProjects ({ project_ref, project_name }) {

				if(project_ref != null)
					return `${project_name} - ${project_ref}`

				return `${project_name}`
			},
			getExport: function(){

				this.loading = true;

				if(this.beginDate){
					var beginMonth = this.beginDate.getMonth() + 1;
					var date1 = this.beginDate.getFullYear() + "-" + ("0"+beginMonth).slice(-2) + "-" + ("0"+this.beginDate.getDate()).slice(-2);
				}
				if(this.endDate){
					var endMonth = this.endDate.getMonth() + 1;
					var date2 = this.endDate.getFullYear() + "-" + ("0"+endMonth).slice(-2) + "-" + ("0"+this.endDate.getDate()).slice(-2);
				}
				var tmpData = new FormData();
				tmpData.append('projectSelected',this.projectSelected.map(obj => obj.project_id));
				tmpData.append('userSelected',this.userSelected.map(obj => obj.id));
				tmpData.append('checkedField',this.checkedField);
				tmpData.append('beginDate',date1);
				tmpData.append('endDate',date2);
				tmpData.append('typeDate',this.typeDate);
				tmpData.append('periodSelected',this.periodSelected === null ? undefined : this.periodSelected.id);
				tmpData.append('regroupingSelected',this.regroupingSelected === null ? undefined : this.regroupingSelected.id);
				tmpData.append('total',this.total);

				axios.post(this.$store.state.apiUrl + "report/reportDocument", tmpData, {
					params: {
						login: localStorage.login,
						password: localStorage.pass
					}
				})
				.then(response => {
					this.formatResponse(response.data);
				})
				.catch(e => {
					this.printError(e);
				});
			},
			formatResponse: function(data){
				
				this.headerReporting = [];
				this.dataReporting = data.alldata;

				if(data.headers == undefined){
					this.dataReporting = false;
					this.loading = false;
					this.$toasted.show("Aucune saisie à afficher", {
						position: 'bottom-center',
						theme: 'outline'
					}).goAway(2500);
					return;
				}
				
				data.headers.forEach(value => {
					if(value != 'totalM' && value != 'totalH'){
						this.headerReporting.push({id:value, value:this.headersText[value]});
						this.json_fields[this.headersText[value]] = value;
					}
				});
				this.totalReporting = data.total;

				if(typeof data.errorlink != "undefined"){
					this.errorDB = data.errorlink;
					console.log(this.errorDB);
				} 
				this.loading = false;
			},
			exportReport: function(){
				var tmpData = new FormData();
				tmpData.append('headers',JSON.stringify(this.headerReporting));
				tmpData.append('data',JSON.stringify(this.dataReporting));
				tmpData.append('total',this.formatDuration(this.totalReporting));
				axios.post(this.$store.state.apiUrl + "report/exportReportDocument", tmpData, {responseType: 'blob'})
				.then((response) => {
					const url = URL.createObjectURL(new Blob([response.data], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
					}))
					const link = document.createElement('a')
					link.href = url;
					link.setAttribute('download', "rapport.xlsx");
					document.body.appendChild(link);
					link.click();
				});
			},
			newReport: function(){
				this.dataReporting = false;
				this.headerReporting = [];
				this.totalReporting = 0;
			},
			formatDuration: function(duration){
				var totalH = String(Math.trunc(duration/60));
				if(totalH.length < 2) totalH = ("00"+totalH).substr(-2);
				var totalM = String(Math.trunc(duration%60));
				if(totalM.length < 2) totalM = ("00"+totalM).substr(-2);
				return totalH+':'+totalM;
			},
			getAllFavoriteReport: function(){
				axios.get(this.$store.state.apiUrl + "report/getAllReportConfig/"+this.userId, {
					params: {
						login: localStorage.login,
						password: localStorage.pass
					}
				})
				.then(response => this.favoris = response.data)
				.catch(e => {
					this.printError(e);
				});
			},
			generateFavorite: function(){
				if(this.favoriSelected.projects){
					var projectsID = this.favoriSelected.projects.split(",");
					this.projectSelected = this.filterProjects.filter(value => value.project_id != null && projectsID.includes(value.project_id.toString()));
				}
				if(this.favoriSelected.users){
					var usersID = this.favoriSelected.users.split(",");
					this.userSelected = this.filterUsers.filter(option => usersID.includes(option.id.toString()));
				}        
				if(this.favoriSelected.checked_field){ this.checkedField = this.favoriSelected.checked_field.split(","); }
				
				if(this.favoriSelected.begin_date != "undefined"){
					var date1 = this.favoriSelected.begin_date.split("-");
					this.beginDate = new Date(Number(date1[0]),Number(date1[1])-1, Number(date1[2]));
				}
				if(this.favoriSelected.end_date != "undefined"){
					var date2 = this.favoriSelected.end_date.split("-");
					this.endDate = new Date(Number(date2[0]),Number(date2[1])-1, Number(date2[2]));
				}

				if(this.favoriSelected.period){ 
					var period = this.periods.filter(option => option.id == this.favoriSelected.period);
					this.periodSelected = period[0];
				}

				if(this.favoriSelected.regrouping){ 
					var regroup = this.regrouping.filter(option => option.id == this.favoriSelected.regrouping);
					this.regroupingSelected = regroup[0];
				}

				this.typeDate = this.favoriSelected.type_date;
				this.total = (this.favoriSelected.total) ? true : false;
			},
			addFavorite: function(){

				this.errors = [];
				if(!this.nameFavorite){
					this.errors.push("Le nom de favori doit être renseigné");
				}
				if(this.errors.length > 0){
					console.log(this.errors);
					return;
				}

				if(this.beginDate){
					var beginMonth = this.beginDate.getMonth() + 1;
					var date1 = this.beginDate.getFullYear() + "-" + ("0"+beginMonth).slice(-2) + "-" + ("0"+this.beginDate.getDate()).slice(-2);
				}
				if(this.endDate){
					var endMonth = this.endDate.getMonth() + 1;
					var date2 = this.endDate.getFullYear() + "-" + ("0"+endMonth).slice(-2) + "-" + ("0"+this.endDate.getDate()).slice(-2);
				}
				var tmpData = new FormData();
				tmpData.append('name',this.nameFavorite);
				tmpData.append('projectSelected',this.projectSelected.map(obj => obj.project_id));
				tmpData.append('userSelected',this.userSelected.map(obj => obj.id));
				tmpData.append('checkedField',this.checkedField);
				tmpData.append('beginDate',date1);
				tmpData.append('endDate',date2);
				tmpData.append('typeDate',this.typeDate);
				tmpData.append('periodSelected',this.periodSelected.id);
				tmpData.append('regroupingSelected',this.regroupingSelected.id);
				tmpData.append('total',this.total);

				axios.post(this.$store.state.apiUrl + "report/addReportConfig/"+this.userId, tmpData, {
					params: {
						login: localStorage.login,
						password: localStorage.pass
					}
				})
				.then(response => { 
					if(response.status == 203){
						this.errors = ["Le nom de favoris doit être unique"];
					}else{
						this.favoris = response.data; this.nameFavorite = "";
					}
				}).catch(e => {
					this.printError(e);
				});
			},
			deleteFavorite: function(){
				axios.delete(this.$store.state.apiUrl + "report/deleteReportConfig/"+this.userId+"/"+this.favoriSelected.id, {
					params: {
						login: localStorage.login,
						password: localStorage.pass
					}
				})
				.then(response =>{ this.favoris = response.data; this.favoriSelected = null;})
				.catch(e => {
					this.printError(e);
				});
			},
			printError: function(e) {
				console.log(e);
				this.$toasted.show("Erreur de connexion, veuillez essayer ultérieurement", {
						position: 'bottom-center',
						theme: 'outline'
				}).goAway(2000);
			},
		},
	};
</script>

<style scoped>
	#favoris {
		margin: auto;
		text-align: center;
		padding: 2em;
	}
	#favoris * { display: inline }
	#favoris .btnFav { width: 100px; margin: 0 10px; padding: 11px 15px; }

	.selectInput { margin-top: 1em; }
	.selectImputMidWith { width: 48%; display: inline-block; }
	#datePicker1 { 
		margin-right: 0.7em;
		vertical-align: top;
	}
	#checkboxInput { display:flex; justify-content: space-evenly }
	#radioDate, #radioModif { margin: 1em 0.36em 0 0; }

	#renderData th { min-width: 170px; }

	#export, #newExport {
		display: block;
		margin: 1em;
		width: max-content;
	}

	#actionExport{ display: flex; justify-content: center; }

	form, #renderData {
		margin: auto;
		text-align: center;
		display: inline-block;
		padding: 2em;
	}

	form input {
		border: 1px solid #ced4da;
		border-radius: .25rem;
		margin-bottom: 1.5em;
		padding: 4px;
	}

	.btn {
		width: 80%;
	}

	.btn {
		margin-top: 1.8em;
	}

	.error {
		display: block;
		color: #dc3545;
		text-align: center;
	}

	.separator_table{
		border-top: 1px solid #ddd;
	}

	.editForm{
		width: 50%;
	}

	@media screen and (max-width: 800px){
		.multiselect{
			margin-bottom: 15px;
		}
	}
</style>